export const getStudy = `query MyQuery($id: String!){
  getStudy(id: $listname) {
    UserListID
    Administration
    ID
    Species
    Sponsor
    Strain
    StudyName
    TestFacility
    Type
  }
}
`;

export const listStudy = `query MyQuery{
  listStudies {
    UserListID
    Administration
    ID
    Species
    Sponsor
    Strain
    StudyName
    TestFacility
    Type
  }
}
`;

export const mutateCreateStudy = `mutation MyMutation (
  $UserListID: String!,
  $Administration: String,
  $Species: String,
  $Sponsor: String,
  $Strain: String,
  $StudyName: String,
  $TestFacility: String,
  $Type: String
) {
  createStudy(study: {
    UserListID: $UserListID, 
    Administration: $Administration, 
    Species: $Species, 
    Sponsor: $Sponsor, 
    Strain: $Strain, 
    StudyName: $StudyName, 
    TestFacility: $TestFacility, 
    Type: $Type
  }) {
    UserListID
    Administration
    ID
    Species
    Sponsor
    Strain
    StudyName
    TestFacility
    Type
  }
}`;

export const mutateRemoveStudy = `mutation MyMutation ($id: String!) {
  deleteStudy(id: $id) {
    UserListID
    Administration
    ID
    Species
    Sponsor
    Strain
    StudyName
    TestFacility
    Type
  }
}`;

export const mutateUpdataStudy = `mutation MyMutation(
  $UserListID: String!,
  $Administration: String,
  $Species: String,
  $Sponsor: String,
  $Strain: String,
  $StudyName: String,
  $TestFacility: String,
  $Type: String,
  $ID: String!
) {
  updateStudy(
    study:{
      UserListID: $UserListID, 
      Administration: $Administration, 
      Species: $Species, 
      Sponsor: $Sponsor, 
      Strain: $Strain, 
      StudyName: $StudyName, 
      TestFacility: $TestFacility, 
      Type: $Type
      ID: $ID
    }
  ) {
    UserListID
    Administration
    ID
    Species
    Sponsor
    Strain
    StudyName
    TestFacility
    Type
  }
}`